// extracted by mini-css-extract-plugin
export default {"resultButton":"ProcessResult_resultButton__Oykw2"};